import './_animations';
import './_images';
import './_fonts';
import '../styles/app.scss';

import 'regenerator-runtime/runtime';
import 'owl.carousel2';
import WOW from 'wow.js';
import 'magnific-popup';
import 'jquery-touchswipe';

import * as Helper from './utils/helpers.js';
import { UkCustomerDaySwiper } from "./widgets/UkCustomerDaySwiper.js";
import { SolutionBenefitsWidget } from './widgets/solutionBenefitsWidget.js';
import { RepresentativesWidget } from './widgets/representativesWidget.js';
import { CashlessSolutionsWidget } from './widgets/cashlessSolutionsWidget.js';
import { WhyNayaxAdvantagesWidget } from './widgets/whyNayaxAdvantagesWidget.js';
import { UpcomingWebinarsSlider } from './widgets/upcomingWebinarsSlider.js';
import { PastWebinarsSlider } from './widgets/pastWebinarsSlider.js';
import { BusinessTypesShortcode } from './widgets/businessTypesShortcode.js';
import { GlobalPresenceShortcode } from './widgets/GlobalPresenceShortcode.js';
import { UpcomingWebinarsShortcode } from './widgets/UpcomingWebinarsShortcode';
import { UpcomingEventsShortcode } from './widgets/UpcomingEventsShortcode.js';
import { PastEventsShortcode } from './widgets/PastEventsShortcode.js';
import { SupportSearch } from './widgets/SupportSearch';
import { SolutionSinglePage } from './widgets/SolutionSinglePage';
import { SolutionFeaturesShortcode } from './widgets/SolutionFeaturesShortcode';
import { WebinarHsForm } from './widgets/WebinarHsForm';
import { MomaUpdatesNav } from './widgets/MomaUpdatesNav';
import { HsFormCfComponent } from './components/HsFormCfComponent';
import { ResourceSingleComponent } from './components/ResourceSingleComponent';
import { HomeVideoComponent } from "./components/HomeVideoComponent";
import NewsLetterModalWidget from "./widgets/NewsLetterModalWidget";
import PartnersLogoCarousel from "./components/PartnersLogoCarousel";
import CalculatorGF from "./components/CalculatorGF";
import MondaySelect from "./components/MondaySelect";
import SolutionSlider from "./components/SolutionSlider.js";
import ProductComparisonSlider from "./components/ProductComparisonSlider.js";
import InstallationSlider from "./components/InstallationSlider.js";
import BtInstallationsSlider from "./components/BtInstallationsSlider.js";
import BlogSlider from "./components/BlogSlider.js";
import SuccessStorySlider from "./components/SuccessStorySlider.js";
import RelatedPosts from "./components/RelatedPosts.js";
import StickyMenu from "./components/StickyMenu.js";
import CustomYoutube from "./components/CustomYoutube";
import Dropdown from "./components/Dropdown";
import "./widgets/supportForm";
import ResourcesPage from "./components/ResourcesPage";
import Faq from "./components/Faq";
import BenefitsBT from "./components/BenefitsBT";
import BTProductsSlider from "./components/BTProductsSlider";
import BTPostsSlider from "./components/BTPostsSlider";
import PressRelease from "./components/PressRelease";
import Legal from "./components/Legal";
import ProductBenefits from "./components/ProductBenefits";
import ProductSolutions from "./components/ProductSolutions";
import ProductSliderSolutions from "./components/ProductSliderSolutions";
import PaymentMethodBT from "./components/PaymentMethodBT";
import { GlossaryFiltering } from "./components/GlossaryFiltering";
import Glossary from "./components/glossary";
import ImagesSlider from "./components/ImagesSlider";
import BtLocations from "./components/BtLocations";
import RetailForm from "./components/RetailForm";
import Range from "./components/Range";

document.addEventListener(
	'DOMContentLoaded',
	() => {
		const wow = new WOW();
		wow.init();

		const ukCustomerDaySwiper = new UkCustomerDaySwiper(5000);
		ukCustomerDaySwiper.init();

		const businessTypesShortcode = new BusinessTypesShortcode();
		businessTypesShortcode.init();

		// NewLetter Modal Widget
		new NewsLetterModalWidget();

		const solutionBenefitsWidget = new SolutionBenefitsWidget();
		solutionBenefitsWidget.init();

		const whyNayaxAdvantagesWidget = new WhyNayaxAdvantagesWidget();
		whyNayaxAdvantagesWidget.init();

		const upcomingWebinarsSlider = new UpcomingWebinarsSlider();
		upcomingWebinarsSlider.init();

		const pastWebinarsSlider = new PastWebinarsSlider();
		pastWebinarsSlider.init();

		new RepresentativesWidget();

		new CashlessSolutionsWidget();

		//Initiate only on contact page
		if (document.getElementById('map')) {
			new GlobalPresenceShortcode();
		}

		new UpcomingWebinarsShortcode();

		new UpcomingEventsShortcode();

		new PastEventsShortcode();

		new SupportSearch('support-search');

		new SolutionSinglePage();

		new SolutionFeaturesShortcode();

		new ProductBenefits();

		new ProductSliderSolutions();

		new ProductSolutions();

		new ImagesSlider();

		new BenefitsBT();

		new ResourcesPage();

		new RetailForm();

		new Faq();

		new Glossary();

		new PressRelease();

		new Legal();

		new Range();

		new PartnersLogoCarousel();

		new PaymentMethodBT();

		new CalculatorGF();

		new MondaySelect();

		new BTProductsSlider();

		new BTPostsSlider();

		new SolutionSlider();

		new ProductComparisonSlider();

		new InstallationSlider();

		new BtInstallationsSlider();

		new BlogSlider();

		new SuccessStorySlider();

		new CustomYoutube();

		new Dropdown();

		new RelatedPosts();

		new StickyMenu();

		new BtLocations();

		const webinarHsForm = new WebinarHsForm();
		webinarHsForm.initialize();

		new MomaUpdatesNav();

		GlossaryFiltering();

		const hsFormCFComponent = new HsFormCfComponent(
			'.hs-form-wrapper_with-cf .hs-form'
		);
		hsFormCFComponent.initializeForm();

		const resourceSingleComponent = new ResourceSingleComponent();
		resourceSingleComponent.initialize();

		const homeVideoComponent = new HomeVideoComponent();
		homeVideoComponent.initialize();

		Helper.preventAction(jQuery('.repeater-list__logos a'));
		Helper.preventAction(jQuery('.toggle-custom .gallery a'));

		const $titles = jQuery('.feature-box__title');
		const $titlesGroup1 = $titles.slice(0, 2);
		const $titlesGroup2 = $titles.slice(2);
		const $descriptions = jQuery('.feature-box__description');
		const $descriptionsGroup1 = $descriptions.slice(0, 2);
		const $descriptionsGroup2 = $descriptions.slice(2);

		if (jQuery(window).width() <= 1024) {
			Helper.setEqualHeight($titlesGroup1);
			Helper.setEqualHeight($titlesGroup2);
			Helper.setEqualHeight($descriptionsGroup1);
			Helper.setEqualHeight($descriptionsGroup2);
		}

		Helper.setAnimatedIcon();
		Helper.setAnimatedIconFeatures();

		jQuery('.elementor-location-header .mobile-plus-toggle-menu').click(
			function () {
				Helper.toggleBodyLock();
				jQuery('.plus-navigation-inner .plus-mobile-menu-content').toggleClass('open');
				return false;
			}
		);

		/* eslint-disable no-unused-vars */
		window.addEventListener('resize', function (event) {
			if (jQuery(window).width() <= 1024) {
				Helper.setEqualHeight($titlesGroup1);
				Helper.setEqualHeight($titlesGroup2);
				Helper.setEqualHeight($descriptionsGroup1);
				Helper.setEqualHeight($descriptionsGroup2);
			}
		});

		var element = document.getElementById('ez-toc-simulator');

		if (element) {
			element.remove();
		}
	},
	false
);
